import { Ignore } from '@master/annotation/Ignore'
import { sortBy } from 'lodash/fp'
import { MetaList } from '@master/model/common/MetaList'
import { PayeeMeta, PayeeMetaHeaders } from './PayeeMeta'

export class PayeeMetaList extends MetaList<PayeeMeta> {
  list: PayeeMeta[]

  constructor (data: (string | number)[][]) {
    super(PayeeMetaHeaders, data, PayeeMeta)
    // sort product based on name
    this.list = sortBy((payee) => payee.payeeFullname, this.list)
  }

  @Ignore()
  get options () {
    return this.list.map((payee) => {
      return {
        label: payee.payeeFullname,
        value: payee.oid
      }
    })
  }
}
